import React, { forwardRef } from 'react';
import cx from 'classnames';
import { Styled } from './styles.js';
import styles from './index.module.scss.js';

const ArcPseudoBg = forwardRef(
  ({ className, style, isBgActive, tagName, v2, children, ...props }, forwardedRef) => /* @__PURE__ */ React.createElement(
    Styled,
    {
      ...props,
      ref: forwardedRef,
      as: tagName,
      className: cx(styles.box, className, {
        [styles.v2]: v2,
        [styles.active]: !!isBgActive
      }),
      style
    },
    children
  )
);
ArcPseudoBg.displayName = "ArcPseudoBg";

export { ArcPseudoBg };
//# sourceMappingURL=index.js.map
